import { render, staticRenderFns } from "./InputAttributeDefinitionsSelector.global.vue?vue&type=template&id=29beb2a6&scoped=true&lang=pug&"
import script from "./InputAttributeDefinitionsSelector.global.vue?vue&type=script&lang=ts&"
export * from "./InputAttributeDefinitionsSelector.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputAttributeDefinitionsSelector.global.vue?vue&type=style&index=0&id=29beb2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29beb2a6",
  null
  
)

export default component.exports